import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Params } from '@angular/router';
import { apis } from '../config/api';
import { HttpClient, HttpParams } from '@angular/common/http';
import { SchoolInstructor, User } from '../models';

@Injectable({
  providedIn: 'root'
})

export class SchoolInstructorService {
  http = inject(HttpClient);

  url = apis.schoolInstructors;

  listSchoolInstructors(params: Params, schoolId: string): Observable<{ total: number, instructors: { instructor: User, schoolInstructor: SchoolInstructor }[] }> {
    const httpParams = new HttpParams({ fromObject: params });
    return this.http.get<{ total: number, instructors: { instructor: User, schoolInstructor: SchoolInstructor }[] }>(`${this.url}/${schoolId}`, { params: httpParams })
      .pipe(
        catchError(error => {
          console.error('Error listing school instructors:', error);
          return throwError(() => error);
        })
      );
  }

  addSchoolInstructor(body: Params, schoolId: string): Observable<any> {
    return this.http.post(`${this.url}/${schoolId}`, body)
      .pipe(
        catchError(error => {
          console.error('Error adding school instructor:', error);
          return throwError(() => error);
        })
      );
  }

  updateSchoolInstructor(body: Params, schoolId: string, id: string): Observable<any> {
    return this.http.patch(`${this.url}/${schoolId}/${id}`, body)
      .pipe(
        catchError(error => {
          console.error('Error updating school instructor:', error);
          return throwError(() => error);
        })
      );
  }

  deleteSchoolInstructor(id: string): Observable<any> {
    return this.http.delete(`${this.url}/${id}`)
      .pipe(
        catchError(error => {
          console.error('Error deleting school instructor:', error);
          return throwError(() => error);
        })
      );
  }

  searchSchoolFreelancer(params: Params, email: any, schoolId: string): Observable<{ count: number, freelancers: { instructor: User, schoolInstructor: SchoolInstructor }[] }> {
    const httpParams = new HttpParams({ fromObject: params });
    return this.http.post<{ count: number, freelancers: { instructor: User, schoolInstructor: SchoolInstructor }[] }>(`${this.url}/freelancer/${schoolId}`, { email }, { params: httpParams })
      .pipe(
        catchError(error => {
          console.error('Error searching freelancers:', error);
          return throwError(() => error);
        })
      );
  }

  getSchoolFreelancer(params: Params, schoolId: string): Observable<{ count: number, freelancers: { instructor: User, schoolInstructor: SchoolInstructor }[] }> {
    const httpParams = new HttpParams({ fromObject: params });
    return this.http.get<{ count: number, freelancers: { instructor: User, schoolInstructor: SchoolInstructor }[] }>(`${this.url}/freelancer/${schoolId}`, { params: httpParams })
      .pipe(
        catchError(error => {
          console.error('Error getting freelancers:', error);
          return throwError(() => error);
        })
      );
  }

  inviteSchoolFreelancer(schoolId: string, instructorId: string): Observable<any> {
    return this.http.post(`${this.url}/freelancer/${schoolId}/${instructorId}`, {})
      .pipe(
        catchError(error => {
          console.error('Error inviting freelancer:', error);
          return throwError(() => error);
        })
      );
  }

  deleteSchoolFreelancer(schoolId: string, instructorId: string): Observable<any> {
    return this.http.delete(`${this.url}/freelancer/${schoolId}/${instructorId}`)
      .pipe(
        catchError(error => {
          console.error('Error deleting freelancer:', error);
          return throwError(() => error);
        })
      );
  }

  updateFreelancerStatus(schoolId: string, instructorId: string, status: number): Observable<any> {
    return this.http.patch(`${this.url}/freelancer/${schoolId}/${instructorId}/status`, { status })
      .pipe(
        catchError(error => {
          console.error('Error updating freelancer status:', error);
          return throwError(() => error);
        })
      );
  }

  updateInstructorPerSchool(schoolId: string, instructorId: string, body: any): Observable<any> {
    return this.http.patch(`${this.url}/${schoolId}/${instructorId}/per-school`, body)
      .pipe(
        catchError(error => {
          console.error('Error updating instructor per-school data:', error);
          return throwError(() => error);
        })
      );
  }


  listSchools(params: Params) {
    return this.http.get(`${apis.schoolInstructors}/freelancer-schools`, {
      params
    })
  }

  listRateOverrides(schoolId: string, instructorId: string): Observable<any> {
    return this.http.get(`${this.url}/${schoolId}/${instructorId}/rate-overrides`)
      .pipe(
        catchError(error => {
          console.error('Error listing rate overrides:', error);
          return throwError(() => error);
        })
      );
  }

  createRateOverride(schoolId: string, instructorId: string, body: Params): Observable<any> {
    return this.http.post(`${this.url}/${schoolId}/${instructorId}/rate-overrides`, body)
      .pipe(
        catchError(error => {
          console.error('Error creating rate override:', error);
          return throwError(() => error);
        })
      );
  }

  updateRateOverride(schoolId: string, instructorId: string, id: string, body: Params): Observable<any> {
    return this.http.put(`${this.url}/${schoolId}/${instructorId}/rate-overrides/${id}`, body)
      .pipe(
        catchError(error => {
          console.error('Error updating rate override:', error);
          return throwError(() => error);
        })
      );
  }

  deleteRateOverride(schoolId: string, instructorId: string, id: string): Observable<any> {
    return this.http.delete(`${this.url}/${schoolId}/${instructorId}/rate-overrides/${id}`)
      .pipe(
        catchError(error => {
          console.error('Error deleting rate override:', error);
          return throwError(() => error);
        })
      );
  }
}
